import { render, staticRenderFns } from "./Subscriber.vue?vue&type=template&id=3a810e12&scoped=true"
import script from "./Subscriber.vue?vue&type=script&lang=js"
export * from "./Subscriber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a810e12",
  null
  
)

export default component.exports